'use strict'

// Public hosts are on turbohammer.com. The parent for an account is
// apps.turbohammer.com, so acme is acme.apps.turbohammer.com, the designer
// is designer.acme.apps.turbohammer.com, and the live app is
// app.acme.apps.turbohammer.com. Login is accounts.turbohammer.com.
// The back office is admin.turbohammer.com. Local dev leaves
// TENANT_PARENT_DOMAIN unset and stays on localhost.

const PRODUCT_PARENT = 'apps.turbohammer.com'

function isLocalParent (domain) {

  return domain === 'localhost' || String(domain || '').endsWith('.localhost')
}

function configuredParent (env) {

  const source = env || process.env

  return String(source.TENANT_PARENT_DOMAIN || '').trim().toLowerCase()
}

function productParent (env) {

  const named = configuredParent(env)

  if (named && !isLocalParent(named)) return named

  return PRODUCT_PARENT
}

function apexOf (parent) {

  const parts = String(parent || '').split('.').filter(Boolean)

  if (parts.length > 2) return parts.slice(1).join('.')

  return parts.join('.')
}

function loginOriginFromParent (parent, port) {

  if (isLocalParent(parent)) {

    return `http://login.${parent}:${port || '8080'}`
  }

  return `https://accounts.${apexOf(parent)}`
}

function loginPageUrlFromParent (parent, port) {

  return `${loginOriginFromParent(parent, port)}/#/login`
}

function accountsOrigin (env) {

  const parent = configuredParent(env)

  if (!parent || isLocalParent(parent)) return ''

  const source = env || process.env

  return loginOriginFromParent(parent, source.TENANT_HTTP_PORT)
}

function isAdminHostname (host, env) {

  const name = String(host || '').split(':')[0].toLowerCase()

  return name === `admin.${apexOf(productParent(env))}`
}

function isProductHttpsHost (host, env) {

  const name = String(host || '').toLowerCase()
  const parent = productParent(env)
  const apex = apexOf(parent)

  if (name === `accounts.${apex}` || name === `admin.${apex}`) return true
  if (name === parent || name.endsWith(`.${parent}`)) return true

  return false
}

module.exports = {
  PRODUCT_PARENT,
  isLocalParent,
  configuredParent,
  productParent,
  apexOf,
  loginOriginFromParent,
  loginPageUrlFromParent,
  accountsOrigin,
  isAdminHostname,
  isProductHttpsHost
}
